import React, { useContext } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { trackPageInteraction } from "asos-contentweb-analytics-middleware";
import getConfig from "src/analyticsProvider";
import StoreDataContext from "src/app/context/store-data";
import styles from "./MyAccount.module.css";
import CardSection from "src/app/components/CardSection/CardSection";
import Button from "src/app/components/Button/Button";

export default function MyAccount({ title, description, buttonText }) {
  const {
    language,
    countryCode,
    storeCode,
    keyStoreDataversion,
    myAccountUrl,
  } = useContext(StoreDataContext);
  const CTAref = "help article|my account|get in touch";
  const href = `${myAccountUrl}/my-account?country=${countryCode}&keyStoreDataversion=${keyStoreDataversion}&lang=${language}&store=${storeCode}#CTAref-${CTAref}`;

  function handleClick() {
    const config = getConfig("my-account-button", {
      page: "get in touch",
    });

    trackPageInteraction(config);
    window.open(href, "_self");
  }

  if (!title && !description && !buttonText) return null;

  return (
    <CardSection title={title}>
      {description && (
        <p className={styles.description}>{parse(description)}</p>
      )}

      {buttonText && <Button onClick={handleClick}>{buttonText}</Button>}
    </CardSection>
  );
}

MyAccount.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
};
